(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailSelectRecipientsDialogCtrl', EmailSelectRecipientsDialogCtrl);

    EmailSelectRecipientsDialogCtrl.$inject = ['$scope', 'DialogInstance', 'ContactService', 'email', 'viewOnlyMode'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for selecting recipients before an email is sent
     */
    function EmailSelectRecipientsDialogCtrl($scope, DialogInstance, ContactService, email, viewOnlyMode) {
        /* jshint validthis:true */
        var vm = this;
        vm.viewOnlyMode = viewOnlyMode;
        vm.title = viewOnlyMode ? 'Recipients' : 'Select Recipients';
        var validationReport = [];
        vm.loading = true;
        vm.allRecipientsSelected = true;
        vm.toggleAllRecipients = toggleAllRecipients;
        vm.getEmailAddressDetails = getEmailAddressDetails;
        vm.cancel = cancel;
        vm.send = send;
        vm.toolTipHtml = toolTipHtml;
        vm.showContactInformation = showContactInformation;
        Object.defineProperty(vm, 'validationReport', { get: getFilteredValidationReports });
        Object.defineProperty(vm, 'entityTemplateName', {
            get: function () {
                var fromEntity = _.find(validationReport, function (emailSendReport) { return !_.isNil(emailSendReport.FromEntityTemplateName) && emailSendReport.FromEntityTemplateName !== ''; });
                if (!_.isNil(fromEntity)) {
                    return fromEntity.FromEntityTemplateName;
                } else {
                    return 'Name';
                }
            }
        });

        activate();

        function activate() {
            email.getValidationReport()
                .then(getValidationReportOk, getValidationReportError);

            function getValidationReportOk(data) {
                validationReport = data;
                toggleAllRecipients();
                vm.loading = false;
            }

            function getValidationReportError(error) {
                vm.error = 'Error loading the email validation report.';
                vm.loading = false;
            }

            $scope.$watch('vm.allRecipientsSelected', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    toggleAllRecipients();
                }
            });
        }

        /**
          * Get a filtered list of validation reports.
          *
          * @returns {array} Returns a list of validation reports
          */
        function getFilteredValidationReports() {
            return _.filter(validationReport, function (report) {
                return _.isNil(vm.searchText) ||
                    ((!_.isNil(report.FromEntityPreview) && report.FromEntityPreview.toLowerCase().includes(vm.searchText.toLowerCase())) ||
                    _.some(report.Addresses, function (address) { return !_.isNil(address) && !_.isNil(address.Contact) && !_.isNil(address.Contact.Value) && address.Contact.Value.toLowerCase().includes(vm.searchText.toLowerCase()); }));
            });
        }

        /**
          * Gets the email address information in a user readable format using the supplied email address information.
          *
          * @returns {string} Returns user readable email address information.
          */
        function getEmailAddressDetails(emailAddress) {
            var result = '';

            if (!_.isNil(emailAddress.Type) && emailAddress.Type !== '') {
                result += emailAddress.Type + ": ";
            }

            if (!_.isNil(emailAddress.Contact.Name) && emailAddress.Contact.Name !== '') {
                result += emailAddress.Contact.Name + ' <' + emailAddress.Contact.Value + '>';
            } else {
                result += emailAddress.Contact.Value;
            }

            return result;
        }

        /**
          * Toggles the email recipients between selected and not selected.
          */
        function toggleAllRecipients() {
            angular.forEach(validationReport, function (report) {
                if (!report.Error && !_.isNil(report.Addresses)) {
                    angular.forEach(report.Addresses, function (address) {
                        address.Selected = vm.allRecipientsSelected;
                    });
                }
            });
        }

        function cancel() {
            DialogInstance.cancel();
        }

        /**
          * Generates the send email request object and then closes the dialog returning the request object.
          */
        function send() {
            var sendRequest = { SendEmails: [] };

            angular.forEach(vm.validationReport, function (validationReport) {
                if (_.some(validationReport.Addresses, function (address) { return address.Selected; })) {
                    var sendEmail = { FromEntityId: validationReport.FromEntityId, To: [], Cc: [], Bcc: [] };

                    angular.forEach(validationReport.Addresses, function (address) {
                        if (address.Selected) {
                            switch (address.Type.toLowerCase()) {
                                case 'to':
                                    sendEmail.To.push(address.Contact);
                                    break;
                                case 'cc':
                                    sendEmail.Cc.push(address.Contact);
                                    break;
                                case 'bcc':
                                    sendEmail.Bcc.push(address.Contact);
                                    break;
                            }
                        }
                    });

                    sendRequest.SendEmails.push(sendEmail);
                }
            });

            DialogInstance.ok(sendRequest);
        }

        /**
         *
         * Creates the html code to be shown for the contact tooltip
         *
         * @returns {string} html code describing the supplied contact
         */
        function toolTipHtml(contact) {
            return ContactService.getToolTipHtml(contact);
        }

        /**
         *
         * Checks the contact to determine if a tool tip shown be shown
         *
         * @returns {bool} does the contact contain information that needs to be shown in a tool tip
         */
        function showContactInformation(contact) {
            return ContactService.showContactInformation(contact);
        }
    }
})();
